import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles/candidate-card.module.css'
import {Button, Card} from "antd";
import {formatSalaryText} from "@/helpers/SalaryInputHelper";

const CandidateCard = props => {
    const {candidate} = props
    return (
        <Card className={styles.wrapper}
              actions={[
                  <Button type={props.isSelected ? "primary" : "link"} danger={props.isSelected} block
                          disabled={!props.isActive}
                          onClick={() => {
                              props.select(candidate)
                          }} className={styles.button}>
                      {props.isSelected ? 'Unselect' : 'Select'}
                  </Button>
              ]}>
            <div className={styles.text_wrapper}>
                <p className={styles.title}>
                    Preferred Job title: {candidate?.preferred_job_titles ? candidate?.preferred_job_titles : '-'}
                </p>
                <p className={styles.text}>Location: {candidate?.city ? candidate?.city : '-'}</p>
                <p className={styles.text}>{`Desired Salary: ${formatSalaryText(candidate?.salary)}`}</p>
                    <p className={styles.text}>
                        Skills: {candidate?.skills?.length > 0
                            ? candidate?.skills?.map((skill, i) => i > 9 ? null :i===0?skill:", "+skill)
                            : '-'}
                    </p>
            </div>
        </Card>
    );
};

CandidateCard.propTypes = {
    isActive: PropTypes.bool.isRequired,
    select: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
    candidate: PropTypes.object.isRequired
};

export default CandidateCard;